<template>
  <main class="about-page safe-page">
    <AppNavBar :title="t('mine.contactUs')" />

    <section class="about-card">
      <app-image src="@/assets/images/appLogo_icon.png" alt="" />
      <app-image src="@/assets/images/apptitle.png" alt="WinPay" class="about-card__title-image" />
      <p>{{ t('mine.contactDesc') }}</p>

      <button type="button" class="about-link" @click="router.push('/mine/support-email')">
        <span>{{ t('mine.supportEmail') }}</span>
        <app-image src="@/assets/images/rightArrow_icon.png" alt="" />
      </button>

      <div class="about-divider" />

      <button type="button" class="about-link about-link--last" @click="router.push('/mine/support-chat')">
        <span>{{ t('mine.onlineSupport') }}</span>
        <app-image src="@/assets/images/rightArrow_icon.png" alt="" />
      </button>
    </section>
  </main>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();
</script>

<style scoped lang="scss">
.about-page {
  min-height: var(--app-viewport-height);
  padding: 0 14px 24px;
  background: #f5f5f5;
}

.about-card {
  padding: 20px 16px 16px;
  border-radius: 16px;
  background: #ffffff;
  text-align: center;

  > .app-image {
    width: 64px;
    height: 64px;
    margin: 0 auto;
    object-fit: contain;
  }

  p {
    margin: 30px 0 0;
    color: #666;
    text-align: left;
    font-size: 14px;
    line-height: 22px;
  }
}

.about-card__title-image {
  width: 135px !important;
  height: 27px !important;
  margin-top: 5px !important;
  object-fit: contain;
}

.about-link {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  padding: 0 0 16px;
  border: 0;
  background: transparent;
  color: #222222;
  font-size: 16px;
  line-height: 22px;
  text-align: left;

  .app-image {
    width: 14px;
    height: 14px;
    margin: 0;
    object-fit: contain;
  }
}

.about-link--last {
  margin-top: 16px;
  padding-bottom: 0;
}

.about-divider {
  width: 100%;
  height: 1px;
  background: #f4f5f6;
}
</style>
